import home from './Home';
import eventPage from './Event';
import normal from './Normal';
import list from './List';
import season from './Season';
import seasons from './Seasons';
import tickets from './Tickets';

export default {
    home,
    normal,
    event: eventPage,
    season,
    seasons,
    tickets,
    notebook: normal,
    list,
};
